import { Kpi } from "src/app/assabil-kernel/models/entities/control-tables/kpi-entity";
import { Partner } from "src/app/assabil-kernel/models/entities/master-data/partner-entity";
import { BaseEntity } from "src/app/tools/models/baseEntity";
import { LoyaltyProgramRelease } from "./loyalty-program-release";


export class LoyaltyProgramReleaseThreshold extends BaseEntity{
    
    loyaltyProgramRelease                   : LoyaltyProgramRelease;
    id                                      : number;
    kpi                                     : Kpi;
    threshold                               : number;
    partner                                 : Partner;

    flat	                                : number;	
    rate	                                : number;	
    minimum	                                : number;	
    maximum	                                : number;	
    vipFlat	                                : number;	
    vipRate	                                : number;	
    vipMminimum	                            : number;	
    vipMaximum	                            : number;	


}
